import { Close } from '@mui/icons-material'
import { Box, Dialog, Grid, IconButton } from '@mui/material'
import CustomTypography from 'components/Fileds/CustomTypography'
import React from 'react'
import CreateAutomaticSlotForm from './CreateAutomaticSlotForm'
import AddNewSlotForm from './AddNewSlotForm'
import theme from 'theme/ThemeContext'
import { useGetTimeSlotsCategoryQuery } from 'pages/timeSlots/services'
import { useGetVendorTimingsQuery } from 'pages/restaurantTimings/services'
import RestaurantTimingHeader from './RestaurantTimingHeader'

const AddTimeSlots = ({ open, onClose, onAddCategory, initialData, initialFormType }) => {

    const { data: categoryList, loading } = useGetTimeSlotsCategoryQuery();
    const { data: vendorTimings } = useGetVendorTimingsQuery();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            className="generic-dialog-container"
            PaperProps={{ sx: { borderRadius: '20px', padding: '10px', color: 'black' } }}
        >
            <Box className='d-flex align-items-center justify-content-center' sx={{ m: 0, p: 2 }}>
                <IconButton aria-label="close" onClick={onClose} className='close-icon-container'>
                    <Close />
                </IconButton>
            </Box>

            <Box sx={{ px: 4, pt: 0, pb: 0 }}>
                <RestaurantTimingHeader vendorTimings={vendorTimings?.data} />
            </Box>

            <Grid container sx={{ padding: '10px 30px', paddingTop: '0px' }}>
                <Grid item md={6} sx={{ pr: 2, borderRight: '1px solid #E0E0E0', width: '50%' }}>
                    <Box sx={{ mb: 2 }}>
                        <CustomTypography
                            variant="h6"
                            label={"Create Automatic"}
                            sx={{
                                textAlign: 'center', mb: 1,
                                fontSize: '24px', fontWeight: 700, color: theme.palette.typographyLabel.main
                            }}
                        />
                        <CustomTypography
                            variant="body2"
                            label={"This generates multiple time‑slots automatically through below query."}
                            sx={{
                                textAlign: 'center', mb: 0,
                                fontSize: '16px', fontWeight: 400, color: theme.palette.lightgrey.main
                            }}
                        />
                    </Box>
                    <CreateAutomaticSlotForm
                        categories={categoryList?.data?.records}
                        handleCloseModal={onClose}
                        onAddCategory={onAddCategory}
                        initialData={initialFormType === 'automatic' ? initialData : null}
                        vendorTimings={vendorTimings?.data}
                    />
                </Grid>

                <Grid item md={6} sx={{ pl: 2, width: '50%' }}>
                    <Box sx={{ mb: 2 }}>
                        <CustomTypography
                            variant="h6"
                            label={"Add New Time Slot"}
                            sx={{
                                textAlign: 'center', mb: 0,
                                fontSize: '24px', fontWeight: 700, color: theme.palette.typographyLabel.main
                            }}
                        />
                    </Box>
                    <AddNewSlotForm
                        categories={categoryList?.data?.records}
                        handleCloseModal={onClose}
                        onAddCategory={onAddCategory}
                        initialData={initialFormType === 'manual' ? initialData : null}
                        vendorTimings={vendorTimings?.data}
                    />
                </Grid>
            </Grid>
        </Dialog>

    )
}

export default AddTimeSlots
